import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AccountLayoutComponent } from "./_layout/account-layout/account-layout.component";
import { NotFoundComponent } from "./error/not-found/not-found.component";
import { LoginComponent } from "./account/login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AboutComponent } from "./about/about.component";

import { SiteFooterComponent } from "./_layout/site-footer/site-footer.component";
import { SiteHeaderComponent } from "./_layout/site-header/site-header.component";
import { SiteLayoutComponent } from "./_layout/site-layout/site-layout.component";
import { SiteSideMenuComponent } from "./_layout/site-side-menu/site-side-menu.component";
import { SiteContentHeaderComponent } from "./_layout/site-content-header/site-content-header.component";

import { AccountFooterComponent } from "./_layout/account-footer/account-footer.component";
import { AccountHeaderComponent } from "./_layout/account-header/account-header.component";
import { InternalServerComponent } from "./error/internal-server/internal-server.component";
import { ForbiddenComponent } from "./error/forbidden/forbidden.component";
import { AuthorizationRequiredComponent } from "./error/authorization-required/authorization-required.component";
import { BadRequestComponent } from "./error/bad-request/bad-request.component";
import { UserLoginProfileComponent } from "./_layout/user-login-profile/user-login-profile.component";

import { ForgetAccountComponent } from "./account/forget-account/forget-account.component";
import { RegisterAccountComponent } from "./account/register-account/register-account.component";
import { ResetPasswordComponent } from "./account/reset-password/reset-password.component";
import { ChangePasswordComponent } from "./manage-account/change-password/change-password.component";
import { ResetPasswordConfirmationComponent } from "./account/reset-password-confirmation/reset-password-confirmation.component";
import { LockAccountComponent } from "./account/lock-account/lock-account.component";
import { ServiceUnavailableComponent } from "./error/service-unavailable/service-unavailable.component";
import { AuthGuard } from "./service/auth/auth.guard";
import { Configuration } from "./configuration";
import { UserProfileComponent } from "./manage-account/user-profile/user-profile.component";
import { EditUserProfileComponent } from "./manage-account/edit-user-profile/edit-user-profile.component";
import { ApplicationSummaryComponent } from "./application-summary/application-summary.component";
import { InstructionComponent } from "./instruction/instruction.component";
import { PersonalComponent } from "./personal/personal.component";
import { PersonalInfoComponent } from "./personal-info/personal-info.component";
import { PersonalContactComponent } from "./personal-contact/personal-contact.component";
import { PersonalGuardianInfoComponent } from "./personal-guardian-info/personal-guardian-info.component";
import { ProgrammeSelectionComponent } from "./programme-selection/programme-selection.component";
import { UploadImageComponent } from "./upload-image/upload-image.component";
import { MainWizardComponent } from "./wizard-layout/main-wizard/main-wizard.component";
import { HeaderWizardComponent } from "./wizard-layout/header-wizard/header-wizard.component";
import { SignUpAccountComponent } from "./account/sign-up-account/sign-up-account.component";
import { AccountLayoutV2Component } from "./_layout/account-layout-v2/account-layout-v2.component";
import { ConfirmationDialogComponent } from "./widget/confirmation-dialog/confirmation-dialog.component";
import { QuickHelpTourDialogComponent } from "./widget/quick-help-tour-dialog/quick-help-tour-dialog.component";
import { PdfDownloadDialogComponent } from "./widget/pdf-download-dialog/pdf-download-dialog.component";
import { PdfViewerComponent } from "./widget/pdf-viewer/pdf-viewer.component";
import { SafePipe, AplicantSearchPipe } from "./pipes/safe.pipe";
import { ApplicantExaminationComponent } from "./applicant-examination/applicant-examination.component";
import { MainPostGraduateExamComponent } from "./post-graduate-examination/main-post-graduate-exam/main-post-graduate-exam.component";
import { EditCertificateComponent } from "./post-graduate-examination/certificate-histroy/edit-certificate/edit-certificate.component";
import { ListCertificateComponent } from "./post-graduate-examination/certificate-histroy/list-certificate/list-certificate.component";
import { EditResearchExperienceComponent } from "./post-graduate-examination/research-experience/edit-research-experience/edit-research-experience.component";
import { ListResearchExperienceComponent } from "./post-graduate-examination/research-experience/list-research-experience/list-research-experience.component";
import { EditSeniorHighEducationComponent } from "./post-graduate-examination/senior-high-education-histroy/edit-senior-high-education/edit-senior-high-education.component";
import { ListSeniorHighEducationComponent } from "./post-graduate-examination/senior-high-education-histroy/list-senior-high-education/list-senior-high-education.component";
import { EditUniversityEducationComponent } from "./post-graduate-examination/university-education-histroy/edit-university-education/edit-university-education.component";
import { ListUniversityEducationComponent } from "./post-graduate-examination/university-education-histroy/list-university-education/list-university-education.component";
import { ListWorkExperienceComponent } from "./post-graduate-examination/work-experience-histroy/list-work-experience/list-work-experience.component";
import { EditWorkExperienceComponent } from "./post-graduate-examination/work-experience-histroy/edit-work-experience/edit-work-experience.component";
import { PostgraduateProgrammeSelectionComponent } from "./postgraduate-programme-selection/postgraduate-programme-selection.component";
import { AdmittedApplicantLayoutComponent } from "./_layout/admitted-applicant-layout/admitted-applicant-layout.component";
import { SearchAdmissionListComponent } from "./admitted-applicant/search-admission-list/search-admission-list.component";
import { ApplicantCongratulationComponent } from "./admitted-applicant/applicant-congratulation/applicant-congratulation.component";
import { LoaderV1Component } from "./widget/loader-v1/loader-v1.component";
import { LoaderV2Component } from "./widget/loader-v2/loader-v2.component";
import { ChooseCampusComponent } from "./choose-campus/choose-campus.component";
import { DocumentUploadComponent } from "./document-upload/document-upload.component";
import { AddEditDocumentComponent } from "./document-upload/add-edit-document/add-edit-document.component";

const routes: Routes = [
  {
    path: "",
    component: AccountLayoutComponent,
    children: [{ path: "", component: LoginComponent, pathMatch: "full" }],
  },
  {
    path: "admission-list",
    component: AdmittedApplicantLayoutComponent,
    children: [
      {
        path: "",
        component: SearchAdmissionListComponent,
        pathMatch: "full",
      },
      { path: "search", component: SearchAdmissionListComponent },
      {
        path: "congrats",
        component: ApplicantCongratulationComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "accountv2",
    component: AccountLayoutV2Component,
    children: [
      { path: "sign-up", component: SignUpAccountComponent, pathMatch: "full" },
    ],
  },

  {
    path: "account",
    component: AccountLayoutComponent,
    children: [
      { path: "", component: LoginComponent, pathMatch: "full" },
      { path: "login", component: LoginComponent, pathMatch: "full" },
      {
        path: Configuration.routerData.forgetPassword.path,
        component: ForgetAccountComponent,
      },
      {
        path: Configuration.routerData.resetPassword.path,
        component: ResetPasswordComponent,
        // ,canActivate: [AuthGuard]
      },
      {
        path: Configuration.routerData.changePassword.path,
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: Configuration.routerData.resetPasswordConfirmation.path,
        component: ResetPasswordConfirmationComponent,
      },
      {
        path: Configuration.routerData.registerAccount.path,
        component: RegisterAccountComponent,
      },
      {
        path: Configuration.routerData.lockAccount.path,
        component: LockAccountComponent,
        canActivate: [AuthGuard],
      },
    ],
  },

  // Main Site Layout
  {
    path: "applicant",
    component: SiteLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", component: DashboardComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "choose-campus", component: ChooseCampusComponent },
      {
        path: "info",
        component: MainWizardComponent,
        children: [
          { path: "", component: InstructionComponent },

          { path: "notices", component: InstructionComponent },
          { path: "upload-image", component: UploadImageComponent },
          // 1st Route
          {
            path: "personal",
            component: PersonalComponent,
            children: [
              { path: "", component: PersonalInfoComponent },
              { path: "basic", component: PersonalInfoComponent },
              { path: "contact", component: PersonalContactComponent },
              { path: "guardian", component: PersonalGuardianInfoComponent },
            ],
          },
          { path: "exam-info", component: ApplicantExaminationComponent },
          {
            path: "programme-selection",
            component: ProgrammeSelectionComponent,
          },
          {
            path: "documents",
            component: DocumentUploadComponent,
          },
          {
            path: "application-summary",
            component: ApplicationSummaryComponent,
          },
          { path: "download", component: PdfViewerComponent },

          { path: "post-exam-info", component: MainPostGraduateExamComponent },
          { path: "post-univ", component: ListUniversityEducationComponent },
          { path: "post-research", component: ListResearchExperienceComponent },
          {
            path: "post-work-experience",
            component: ListWorkExperienceComponent,
          },
          {
            path: "post-high-school",
            component: ListSeniorHighEducationComponent,
          },
          { path: "post-certificate", component: ListCertificateComponent },
          {
            path: "post-programme",
            component: PostgraduateProgrammeSelectionComponent,
          },
        ],
      },

      // { path: 'profile', component: UserProfileComponent },
      // { path: 'edit-profile', component: EditUserProfileComponent },
      // { path: 'about', component: AboutComponent },
      // { path: 'instruction', component: InstructionComponent },
      // { path: 'application-summary', component: ApplicationSummaryComponent },
      // { path: 'exam-info', component: ExaminationInfoComponent },
      // { path: 'person-info', component: PersonalInfoComponent },
      // { path: 'programme-selection', component: ProgrammeSelectionComponent },
      // { path: 'upload-image', component: UploadImageComponent },
    ],
  },

  { path: "**", component: NotFoundComponent },
  { path: "p400", component: BadRequestComponent },
  { path: "p401", component: AuthorizationRequiredComponent },
  { path: "p403", component: ForbiddenComponent },
  { path: "p404", component: NotFoundComponent },
  { path: "p500", component: InternalServerComponent },
  { path: "p503", component: ServiceUnavailableComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const routingComponents = [
  AccountLayoutV2Component,
  SiteLayoutComponent,
  SiteFooterComponent,
  SiteHeaderComponent,
  SiteSideMenuComponent,
  SiteContentHeaderComponent,
  UserLoginProfileComponent,
  DashboardComponent,
  AboutComponent,
  UserProfileComponent,
  EditUserProfileComponent,
  ApplicantExaminationComponent,

  ApplicationSummaryComponent,
  InstructionComponent,
  PersonalInfoComponent,
  ProgrammeSelectionComponent,
  UploadImageComponent,
  ApplicantExaminationComponent,
  DocumentUploadComponent,
  ChooseCampusComponent,

  MainWizardComponent,
  HeaderWizardComponent,
  PersonalComponent,
  PersonalContactComponent,
  PersonalGuardianInfoComponent,

  // Postgraduate
  MainPostGraduateExamComponent,
  EditCertificateComponent,
  ListCertificateComponent,
  EditResearchExperienceComponent,
  ListResearchExperienceComponent,
  EditSeniorHighEducationComponent,
  ListSeniorHighEducationComponent,
  EditUniversityEducationComponent,
  ListUniversityEducationComponent,
  ListWorkExperienceComponent,
  EditWorkExperienceComponent,
  PostgraduateProgrammeSelectionComponent,
  SearchAdmissionListComponent,
  AdmittedApplicantLayoutComponent,
  ApplicantCongratulationComponent,
  // Pipes
  SafePipe,
  AplicantSearchPipe,

  // Account Layout Component
  AccountLayoutComponent,
  AccountFooterComponent,
  AccountHeaderComponent,
  LoginComponent,
  ForgetAccountComponent,
  RegisterAccountComponent,
  ResetPasswordComponent,
  ChangePasswordComponent,
  ResetPasswordConfirmationComponent,
  LockAccountComponent,
  SignUpAccountComponent,
  LoaderV1Component,
  LoaderV2Component,

  // Error Pages
  InternalServerComponent,
  ForbiddenComponent,
  AuthorizationRequiredComponent,
  BadRequestComponent,
  NotFoundComponent,
  ServiceUnavailableComponent,

  // Widgets
  ConfirmationDialogComponent,
  QuickHelpTourDialogComponent,
  PdfDownloadDialogComponent,
  PdfViewerComponent,
  AddEditDocumentComponent,
];

export const entryComponents = [
  ConfirmationDialogComponent,
  QuickHelpTourDialogComponent,
  PdfDownloadDialogComponent,
  EditCertificateComponent,
  EditResearchExperienceComponent,
  EditSeniorHighEducationComponent,
  EditUniversityEducationComponent,
  EditWorkExperienceComponent,
  AddEditDocumentComponent,
];
